import { render, staticRenderFns } from "./PrePurchaseList.vue?vue&type=template&id=615a6c7a&scoped=true"
import script from "./PrePurchaseList.vue?vue&type=script&lang=js"
export * from "./PrePurchaseList.vue?vue&type=script&lang=js"
import style0 from "./PrePurchaseList.vue?vue&type=style&index=0&id=615a6c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615a6c7a",
  null
  
)

export default component.exports